import React from "react";
import { motion } from "motion/react";

interface HorizontalScrollProps {
  processSteps: string[];
}

export const HorizontalScroll: React.FC<HorizontalScrollProps> = ({
  processSteps,
}) => {
  return (
    <div className="w-full lg:py-32 md:py-16 py-8">
      <div className="w-full h-fit lg:text-2xl font lg:flex-row flex-col justify-center items-center md:text-lg text-base font-gilroy-bold relative">
        <div className="flex justify-between">
          <p>Steps</p>
          <p className="animate-bounce -rotate-90 lg:hidden block">↓</p>
        </div>
        <hr className="w-full lg:absolute lg:top-1/2 lg:left-24 lg:mt-0 mt-8" />
      </div>

      <div className="flex lg:gap-24 gap-8 overflow-scroll lg:-mt-4 lg:ml-24 w-full">
        <motion.div className="flex lg:gap-24 gap-0 xl:px-32 lg:px-16 px-8 w-fit">
          {processSteps.map((step, index) => (
            <div key={index} className="min-w-[350px] flex flex-col gap-8">
              <hr className="w-16 lg:-ml-4 -ml-[6vw] h-[1px] rotate-90" />
              <p className="lg:text-5xl md:text-3xl pt-4 text-lg font-gilroy-bold">
                {index + 1}
              </p>
              <p className="font-gilroy-regular lg:text-2xl md:text-lg text-base lg:w-fit w-3/4">
                {step}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};
